<template>
  <div class="sectionHeader">
    <div class="title-subtitle">
      <h2 class="title">{{ title }}</h2>
      <p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="actionLabel" class="action" @click="$emit('action')">
      <span>{{ actionLabel }}</span>
      <img src="@/assets/arrow-right.png" alt="arrow" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    },
    actionLabel: {
      type: String,
      default: null
    }
  },
  emits: ['action']
}
</script>

<style scoped>
.sectionHeader {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  background-color: transparent;
  padding: 16px 0;
}
.title {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}
.subtitle {
  font-size: 11px;
  margin: 0;
  margin-top: 4px;
  white-space: nowrap; 
}
.action {
  display: flex;
  align-items: baseline;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap; 
}
.action img {
  margin-left: 8px;
  width: 16px;
  height: 10px;
}
</style>
